import React from "react";
import { Route, BrowserRouter, Routes} from "react-router-dom";

import OnePage from "./pages/onePage/OnePage";
import Artigos from "./pages/artigos/Artigos";
import LerArtigo from "./pages/lerArtigo/LerArtigo";

const rotas = () => {
   return(
       <BrowserRouter>
            <Routes>
                <Route path="/" element={<OnePage/>} exact />
                <Route path="/artigos" element={<Artigos/>} />
                <Route path="/lerArtigo/:id" element={<LerArtigo/>} />

            </Routes>
       </BrowserRouter>
   )
}

export default rotas;